// client_serena/src/pages/PaymentHistoryPage.js
import React, { useEffect, useState } from "react";
import {
Box, Heading, Text, Table, Thead, Tbody, Tr, Th, Td,
Spinner, Tabs, TabList, TabPanels, Tab, TabPanel, Badge
} from "@chakra-ui/react";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const statusColor = (status) => {
switch (status) {
case "paid": return "green";
case "pending": return "yellow";
case "failed": return "red";
default: return "gray";
}
};

const PaymentHistoryPage = () => {
const { token } = useAuth();
const [orders, setOrders] = useState([]);
const [manualPayments, setManualPayments] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
const fetchHistory = async () => {
setLoading(true);
try {
const [ordersRes, manualRes] = await Promise.all([
axios.get(`${API_BASE_URL}/api/orders`, { headers: { Authorization: `Bearer ${token}` } }),
axios.get(`${API_BASE_URL}/api/payments/manual-history`, { headers: { Authorization: `Bearer ${token}` } })
]);
setOrders(ordersRes.data);
setManualPayments(manualRes.data);
} catch (err) {
console.error("Error fetching payment history:", err);
}
setLoading(false);
};
if (token) fetchHistory();
}, [token]);

return (
<Box maxW="4xl" mx="auto" mt={8} p={4}>
<Heading mb={6}>Payment & Order History</Heading>
{loading ? <Spinner size="xl" /> : (
<Tabs isFitted variant="enclosed">
<TabList mb="1em">
<Tab>Paystack Orders</Tab>
<Tab>Manual Payments</Tab>
</TabList>
<TabPanels>
<TabPanel>
<Table variant="simple">
<Thead>
<Tr>
<Th>Date</Th>
<Th>Reference</Th>
<Th>Total (₦)</Th>
<Th>Status</Th>
</Tr>
</Thead>
<Tbody>
{orders.length === 0 && <Tr><Td colSpan={4}><Text>No orders found.</Text></Td></Tr>}
{orders.map(order => (
<Tr key={order._id}>
<Td>{new Date(order.createdAt).toLocaleString()}</Td>
<Td>{order.reference}</Td>
<Td>{order.total}</Td>
<Td><Badge colorScheme={statusColor(order.status)}>{order.status}</Badge></Td>
</Tr>
))}
</Tbody>
</Table>
</TabPanel>

<TabPanel>
<Table variant="simple">
<Thead>
<Tr>
<Th>Date</Th>
<Th>Amount Paid</Th>
<Th>Bank</Th>
<Th>Account Name</Th>
<Th>Status</Th>
</Tr>
</Thead>
<Tbody>
{manualPayments.length === 0 && <Tr><Td colSpan={5}><Text>No manual payments found.</Text></Td></Tr>}
{manualPayments.map(mp => (
<Tr key={mp._id}>
<Td>{new Date(mp.submittedAt).toLocaleString()}</Td>
<Td>{mp.amountPaid}</Td>
<Td>{mp.bankName}</Td>
<Td>{mp.accountName}</Td>
<Td><Badge colorScheme={statusColor(mp.status || "pending")}>{mp.status || "pending"}</Badge></Td>
</Tr>
))}
</Tbody>
</Table>
</TabPanel>
</TabPanels>
</Tabs>
)}
</Box>
);
};

export default PaymentHistoryPage;
